import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { UpdateTocComponent } from './update-toc.component';



@NgModule({
  declarations: [
    UpdateTocComponent,
    
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
  exports:[
      UpdateTocComponent
  ]
})
export class UpdateTocComponentModule { }
